//libary
import React, { Component } from "react";
import { isAndroid, isIOS } from "react-device-detect";
import axios from "axios";
import queryString from "query-string";
import jsCookie from "js-cookie";
//component
import Header from "../Component/Header";
import Warring from "../Component/Warring";
import Footer from "../Component/Footer";
import Swal from "sweetalert2";
//css
import "./index.css";
class redrPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      FundID: "",
      altTrade: "",
      rspTrade: "",
      dspTrade: "",
      fpTrade: "",
      fundName: "",
      nav: "",
      navDate: "",
      warnDesc: "",
      infoReportUrl: "",
      utm_medium: "",
      utm_source: "",
      utm_campaign: "",
      protype: "anue",
      isApp: true,
      altUrl: "",
      rspUrl: "",
      dspUrl: "",
      openacctStr: "",
      footerheight: 64,
    };
  }

  componentWillMount() {
    try {
      let randomNum = Math.round(Math.random() * 10000);
      //let url = process.env.NODE_ENV !== 'production' ? "/MKTString.json?" + randomNum : process.env.REACT_APP_PCSERVER + "/FundSpec/Redr/MKTString.json?" + randomNum
      //axios.get(url, { headers: { 'Content-Type': 'application/json; charset=utf-8' } }).then((response) => {
      //    this.setState({ openacctStr: response.data.openacctStr })
      //})

      const parsed = this.JsonToUpperCase(
        queryString.parse(window.location.search)
      );
      let data = this.getAPIData(parsed);
      if (data !== undefined) {
        if (data["fundID"] !== undefined)
          this.appendLinkCanonical(data["fundID"]);
        axios
          .post(process.env.REACT_APP_APISERVICE + "/api/Index/Redr2/", data, {
            headers: { "Content-Type": "application/json; charset=utf-8" },
          })
          .then((response) => {
            if (response.data.code === "00000") {
              let fundData = response.data.data;
              let FundID = fundData.fundID;
              let altTrade = fundData.altTrade;
              let rspTrade = fundData.rspTrade;
              let dspTrade = fundData.dspTrade;
              let fpTrade = fundData.fpTrade;
              let fundName = fundData.fundName;
              let nav = fundData.nav;
              let navDate = fundData.navDate;
              let warnDesc = fundData.warnDesc;
              let infoReportUrl = fundData.infoReportUrl;
              let utm_medium =
                parsed.utm_medium !== undefined
                  ? parsed.utm_medium.toLowerCase()
                  : undefined;
              let utm_source =
                parsed.utm_source !== undefined
                  ? parsed.utm_source.toLowerCase()
                  : undefined;
              let utm_campaign =
                parsed.utm_campaign !== undefined
                  ? parsed.utm_campaign.toLowerCase()
                  : undefined;
              let protype =
                parsed.proType !== undefined
                  ? parsed.proType.toLowerCase()
                  : undefined;
              //let isApp = (window.anueCB !== undefined) ? true : (parsed.isApp === "1") ? true : false;
              var isApp = false;
              if (navigator.userAgent.indexOf("FundApp") >= 0) isApp = true;
              if (isApp)
                infoReportUrl = "anuefund://?detail=" + fundData.fundID;
              this.setState(
                {
                  FundID,
                  altTrade,
                  rspTrade,
                  dspTrade,
                  fpTrade,
                  fundName,
                  nav,
                  navDate,
                  warnDesc,
                  infoReportUrl,
                  utm_medium,
                  utm_source,
                  utm_campaign,
                  protype,
                  isApp,
                },
                () => {}
              );
              //vincent 0717 SEO
              let titleword = "";
              if (
                warnDesc !== "" &&
                warnDesc !== null &&
                warnDesc !== undefined
              )
                titleword = fundName + "|" + warnDesc + "|鉅亨買基金";
              else titleword = fundName + " | 鉅亨買基金";
              document.title = titleword;
              var metaList = document.getElementsByTagName("meta");
              for (var i = 0; i < metaList.length; i++) {
                if (metaList[i].getAttribute("property") === "title") {
                  metaList[i].content = titleword;
                }
                if (metaList[i].getAttribute("name") === "description") {
                  metaList[i].content =
                    fundName +
                    " | 鉅亨買基金提供全球知名配息基金、債券基金、股票基金等三千檔基金商品，結合AI機器人理財服務，基金申購享終身0信託保管費與配息基金0手續費，線上開戶交易快速方便又安全。";
                }
                if (metaList[i].getAttribute("name") === "keywords") {
                  metaList[i].content =
                    fundName +
                    " | 基金、基金搜尋、基金投資、基金淨值、境外基金、基金優惠、配息基金、債券基金、股票基金、基金手續費、手續費率、網路下單、網路交易、基金交易平台";
                }
              }
            } else {
              alert(response.data.message);
            }
          })
          .catch((error) => {
            alert(error);
          });
      } else {
        alert("連結錯誤，煩請確認網址。");
      }
    } catch (error) {
      alert(error);
    }
  }

  componentDidMount() {
    setTimeout(() => {
      if (window.location.search.indexOf("rspcheck") > -1) {
        if (this.state.rspTrade === "Y")
          document.querySelector("#rspchk").checked = true;
      } else {
        if (this.state.altTrade === "Y")
          document.querySelector("#altchk").checked = true;
      }
    }, 500);

    let footerheight = 64;
    if (window.innerHeight > 854) {
      footerheight += window.innerHeight - 854;
    }
    this.setState({ footerheight });
  }

  getAPIData(parsed) {
    if (parsed.FUNDID !== undefined) {
      return { fundID: parsed.FUNDID };
    } else if (parsed.ISINCODE !== undefined && parsed.CCY) {
      return { isinCode: parsed.ISINCODE, trccy: parsed.CCY };
    }
    return undefined;
  }

  JsonToUpperCase(obj) {
    if (!obj) {
      return;
    }
    if (typeof obj !== "Object" && typeof obj !== "object") {
      return;
    }
    var keys = Object.keys(obj);
    var result = {};
    // eslint-disable-next-line array-callback-return
    keys.map(function (k, v) {
      if (
        typeof k === "string" &&
        (k.toLocaleUpperCase() === "FUNDID" ||
          k.toLocaleUpperCase() === "ISINCODE" ||
          k.toLocaleUpperCase() === "CCY")
      ) {
        result[k.toLocaleUpperCase()] = obj[k];
      } else {
        result[k] = obj[k];
      }
    });
    return result;
  }

  getQueryStr() {
    let { utm_medium, utm_source, utm_campaign, protype } = this.state;
    let qs = { utm_medium, utm_source, utm_campaign, protype };
    if (this.state.isApp === true) {
      qs.anueOpenOuterBrowser = "1";
    }
    let utmStr = queryString.stringify(qs) || "";
    return utmStr;
  }

  appUrlScheme() {
    let before = new Date().valueOf();
    setTimeout(function () {
      let after = new Date().valueOf();
      if (after - before > 1500) {
        return;
      }
      if (isIOS) {
        window.location =
          "https://apps.apple.com/tw/app/%E9%89%85%E4%BA%A8%E8%B2%B7%E5%9F%BA%E9%87%91/id152736072";
      } else if (isAndroid) {
        window.location =
          "https://play.google.com/store/apps/details?id=com.anuefund.investor";
      } else {
        window.location = "https://www.anuefund.com/launch/Join_APP/";
      }
    }, 1200);
    window.location = "anuefund://download";
  }

  getCartList() {
    const cartJson = localStorage.getItem("AnueCartTem");
    let cartList = [];
    if (cartJson) {
      cartList = JSON.parse(cartJson);
    }
    return cartList;
  }

  addToCart(fundID, type, mode) {
    let utm = window.location.href.split("/redr/?")[1];
    let cartList = this.getCartList();

    if (mode === "purchase") {
      cartList = cartList.filter((info) => info.FundID !== fundID);
    }

    cartList.push({ FundID: fundID, Type: type, UTM: utm });
    localStorage.setItem("AnueCartTem", JSON.stringify(cartList));
  }

  clickAddCart(fundID) {
    let type = [];
    try {
      if (document.querySelector("#lowchk").checked) return;
    } catch (e) {}
    if (document.querySelector("#altchk").checked) type.push("A");
    if (document.querySelector("#rspchk").checked) type.push("R");
    if (
      !document.querySelector("#altchk").checked &&
      !document.querySelector("#rspchk").checked
    ) {
      Swal.fire({
        title: "請選擇申購方式",
        confirmButtonText: "　關 閉　",
        confirmButtonColor: "gray",
      });
      return;
    }
    const cartList = this.getCartList();
    //APP 判斷 new
    var confirmText = "加入其他基金";
    if (this.state.isApp) confirmText = "　返 回　";
    if (cartList.find((info) => info.FundID === fundID)) {
      Swal.fire({
        title: "訊息",
        text: "該基金已存在購物車",
        showDenyButton: true,
        confirmButtonText: confirmText,
        denyButtonText: "前往申購",
        confirmButtonColor: "gray",
        denyButtonColor: "#f04d29",
      }).then((res) => {
        if (res.value) {
          if (this.state.isApp) window.location.href = "anuefund://?close";
          else
            window.location.href =
              "https://www.anuefund.com/fund/search?tabname=%E9%89%85%E4%BA%A8%E7%B2%BE%E9%81%B8";
        } else {
          if (res.value === undefined) Swal.close();
          if (res.value === false) this.clickPurchase(fundID, type);
        }
      });
      //alert('該基金已存在購物車');
    } else {
      this.addToCart(fundID, type, "cart");
      Swal.fire({
        title: "訊息",
        text: "加入成功",
        showDenyButton: true,
        confirmButtonText: confirmText,
        denyButtonText: "前往申購",
        confirmButtonColor: "gray",
        denyButtonColor: "#f04d29",
      }).then((res) => {
        if (res.value) {
          if (this.state.isApp) window.location.href = "anuefund://?close";
          else
            window.location.href =
              "https://www.anuefund.com/fund/search?tabname=%E9%89%85%E4%BA%A8%E7%B2%BE%E9%81%B8";
        } else {
          if (res.value === undefined) Swal.close();
          if (res.value === false) this.clickPurchase(fundID, type);
        }
      });
      //alert('加入成功');
    }
  }

  clickPurchase(fundID) {
    let utm = window.location.href.split("/redr/?")[1];
    try {
      if (document.querySelector("#lowchk").checked) {
        window.location.href = "/EC/bottomfishing/" + fundID + "?" + utm;
        return;
      }
    } catch (e) {}
    try {
      if (document.querySelector("#fpchk").checked) {
        window.location.href =
          "/FundSpec/FreePay/trade/search?fundid=" + fundID + "&" + utm;
        return;
      }
    } catch (e) {}

    let type = [];
    if (document.querySelector("#altchk").checked) type.push("A");
    if (document.querySelector("#rspchk").checked) type.push("R");
    if (
      !document.querySelector("#altchk").checked &&
      !document.querySelector("#rspchk").checked
    ) {
      Swal.fire({
        title: "請選擇申購方式",
        confirmButtonText: "　關 閉　",
        confirmButtonColor: "gray",
      });
      return;
    }
    this.addToCart(fundID, type, "purchase");
    window.location.href = "/EC/cart/" + fundID;
  }

  lowchecked() {
    document.querySelector("#altchk").checked = false;
    document.querySelector("#rspchk").checked = false;
    try {
      document.querySelector("#fpchk").checked = false;
    } catch {}
    if (document.getElementById("CAR1").classList.contains("carBtn")) {
      document.getElementById("CAR1").classList.remove("carBtn");
      document.getElementById("CAR1").classList.add("carBtn2");
    }
  }

  fpchecked() {
    document.querySelector("#altchk").checked = false;
    document.querySelector("#rspchk").checked = false;
    try {
      document.querySelector("#lowchk").checked = false;
    } catch {}
    if (document.getElementById("CAR1").classList.contains("carBtn")) {
      document.getElementById("CAR1").classList.remove("carBtn");
      document.getElementById("CAR1").classList.add("carBtn2");
    }
  }

  altchecked() {
    try {
      document.querySelector("#lowchk").checked = false;
    } catch {}
    try {
      document.querySelector("#fpchk").checked = false;
    } catch {}
    if (document.getElementById("CAR1").classList.contains("carBtn2")) {
      document.getElementById("CAR1").classList.remove("carBtn2");
      document.getElementById("CAR1").classList.add("carBtn");
    }
  }

  appendLinkCanonical(fundID) {
    const { protocol, host } = window.location;
    const link = document.createElement("link");
    link.rel = "canonical";
    link.href = `${protocol}//${host}/fund/detail/${fundID}`;
    document.head.appendChild(link);
  }

  render() {
    return (
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <div>
          <div className="blueLine"></div>
          <div className="redLine"></div>
          <div className="orangeLine"></div>
        </div>
        <Header />
        <div className="menu">
          <span className="menuText">申購基金</span>
        </div>
        <div className="infoBlock">
          <div className="info">
            <p>
              {this.state.fundName}
              {this.state.warnDesc}
            </p>
            <span>
              參考淨值：{this.state.nav}({this.state.navDate})
            </span>
            {this.state.utm_source !== "cnyes" &&
            this.state.utm_source !== "moneydj" &&
            this.state.navDate.trim().length >= 8 ? (
              <span className="orderInfoBtn">
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href={this.state.infoReportUrl}
                >
                  更多資訊
                </a>
              </span>
            ) : (
              ""
            )}
            <div></div>
          </div>
          <div
            className="btnBar"
            style={{ textAlign: "center", verticalAlign: "unset" }}
          >
            <label
              style={{
                fontSize: "24px",
                padding: "0px 45px 10px 25px",
                display: "inline-block",
                position: "relative",
              }}
            >
              <input
                style={{ zoom: "1.3" }}
                id="altchk"
                type={"checkbox"}
                disabled={this.state.altTrade !== "Y"}
                onClick={() => {
                  this.altchecked();
                }}
              ></input>
              單筆
            </label>
            <label
              style={{
                fontSize: "24px",
                padding: "0px 0px 10px 25px",
                display: "inline-block",
                position: "relative",
              }}
            >
              <input
                style={{ zoom: "1.3" }}
                id="rspchk"
                type={"checkbox"}
                disabled={this.state.rspTrade !== "Y"}
                onClick={() => {
                  this.altchecked();
                }}
              ></input>
              定期定額
            </label>
            {(this.state.altTrade === "Y" && this.state.rspTrade === "Y") ||
            this.state.fpTrade === "Y" ? (
              <div>
                <table
                  style={{
                    margin: "auto",
                    maxWidth: "254px",
                    width: "254px",
                    color: "#808080",
                    marginBottom: "12px",
                  }}
                >
                  <tr>
                    <td style={{ width: "45%" }}>
                      <hr style={{ width: "95%" }}></hr>
                    </td>
                    <td>或</td>
                    <td style={{ width: "45%" }}>
                      <hr style={{ width: "95%" }}></hr>
                    </td>
                  </tr>
                </table>
                {this.state.altTrade === "Y" && this.state.rspTrade === "Y" ? (
                  <label
                    style={{
                      fontSize: "24px",
                      padding: "0px 20px 30px 25px",
                      display: "inline-block",
                      position: "relative",
                    }}
                  >
                    <input
                      style={{ zoom: "1.3" }}
                      id="lowchk"
                      type={"checkbox"}
                      onClick={() => {
                        this.lowchecked();
                      }}
                    ></input>
                    超底王
                  </label>
                ) : (
                  ""
                )}
                {this.state.fpTrade === "Y" ? (
                  <label
                    style={{
                      fontSize: "24px",
                      padding: "0px 10px 30px 25px",
                      display: "inline-block",
                      position: "relative",
                    }}
                  >
                    <input
                      style={{ zoom: "1.3" }}
                      id="fpchk"
                      type={"checkbox"}
                      onClick={() => {
                        this.fpchecked();
                      }}
                    ></input>
                    自由Pay
                  </label>
                ) : (
                  ""
                )}
              </div>
            ) : (
              <div style={{ width: "100%", height: "20px" }}></div>
            )}
            <span id="ALT1" className="altBtn">
              <span
                onClick={() => {
                  this.clickPurchase(this.state.FundID);
                }}
              >
                立即申購
              </span>
            </span>
            <span id="CAR1" className="carBtn">
              <span
                onClick={() => {
                  this.clickAddCart(this.state.FundID);
                }}
              >
                <i class="fa-solid fa-shopping-cart"></i>&nbsp;加入購物車
              </span>
            </span>
          </div>
        </div>
        <div
          className="infoBlock2"
          style={{ height: this.state.footerheight + "px" }}
        >
          {this.state.isApp === false ? (
            <div className="info">
              <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                終身0手續費！
              </span>
              <a
                style={{
                  fontWeight: "bold",
                  color: "#FF9224",
                  textDecoration: "none",
                  fontSize: "16px",
                }}
                rel="noopener noreferrer"
                target="_blank"
                href={
                  "https://www.anuefund.com/FundSpec/OpenAcct/" +
                  (this.getQueryStr() !== "" ? "?" + this.getQueryStr() : "")
                }
              >
                立即開戶 》
              </a>
              <div style={{ margin: "9px 4%" }}></div>
              <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                買好基金～隨時都行！
              </span>
              <span
                style={{
                  fontWeight: "bold",
                  color: "#3ac2cf",
                  fontSize: "16px",
                }}
                onClick={() => {
                  this.appUrlScheme();
                }}
              >
                立即下載APP 》
              </span>
            </div>
          ) : (
            ""
          )}
        </div>
        <Warring />
        <Footer />
      </div>
    );
  }
}
export default redrPage;
